export default __webpack_public_path__ + "static/media/3.1a7f7e38.png";